import { styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Stack from '../../common/Stack.common'

const Title = styled(Typography)((props) => ({
  fontSize: '1.875rem',
  fontWeight: 800,
  marginBottom: '90px',
  lineHeight: 1.25,
  textAlign: 'center',
  [props.theme.breakpoints.down('sm')]: {
    marginBottom: '40px',
  },
}))

const SectionTitle = styled(Typography)((props) => ({
  color: props.theme.palette.primary.main,
  fontSize: '1.375rem',
  fontWeight: 800,
  lineHeight: 1.25,
}))

const SectionTextContainer = styled(Typography)({
  fontSize: '0.938rem',
  fontWeight: 500,
  whiteSpace: 'pre-line',
})

const SectionTextContainerUrl = styled('span')({ textDecoration: 'underline' })

const TmCgu = () => {
  const { t: tI18n } = useTranslation()
  // No check since the trad only exist on tmConfig
  const t = (string: any) => {
    return tI18n(string as any)
  }

  return (
    <Stack alignItems="center" py="70px" position="relative">
      <Title>{t('cgu:title')}</Title>
      <Stack spacing="50px" width="100%" maxWidth="900px">
        <Stack spacing="15px">
          <SectionTitle>{t('cgu:paragraph1.title')}</SectionTitle>
          <SectionTextContainer>
            {t('cgu:paragraph1.description.part1')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph1.description.part2')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph1.description.part3')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph1.description.part4')}
          </SectionTextContainer>
        </Stack>
        <Stack spacing="15px">
          <SectionTitle>{t('cgu:paragraph2.title')}</SectionTitle>
          <SectionTextContainer>{t('cgu:paragraph2.description')}</SectionTextContainer>
        </Stack>
        <Stack spacing="15px">
          <SectionTitle>{t('cgu:paragraph3.title')}</SectionTitle>
          <SectionTextContainer>
            {t('cgu:paragraph3.description.part1')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph3.description.part2')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph3.description.part3')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph3.description.part4')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph3.description.part5')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph3.description.part6')}
          </SectionTextContainer>
        </Stack>
        <Stack spacing="15px">
          <SectionTitle>{t('cgu:paragraph4.title')}</SectionTitle>
          <SectionTextContainer>
            {t('cgu:paragraph4.description.part1')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph4.description.part2')}
            <SectionTextContainerUrl>{window.location.origin}</SectionTextContainerUrl>
            {t('cgu:paragraph4.description.part3')}
          </SectionTextContainer>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default TmCgu
